import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "all-comments"
}
const _hoisted_2 = { class: "comment-wrapper" }
const _hoisted_3 = { class: "comments__total-count" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "comments__comment" }
const _hoisted_7 = {
  key: 0,
  class: "comments__reply"
}

import { ref } from 'vue'

import CommentComponent from '@/app/components/community/Comment.vue'
import CommentReply from '@/app/components/community/CommentReply.vue'

import { Comment, Thread } from '@/models/interfaces'
import { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'Comments',
  props: {
    doc: {},
    thread: {}
  },
  setup(__props: any) {



const replyComment = ref<Comment | null>(null)

function isShowReply(comment: Comment): boolean {
  return !!replyComment.value && replyComment.value === comment
}

function showReply(comment: Comment): void {
  replyComment.value = comment
}

function hideReply(): void {
  replyComment.value = null
}

return (_ctx: any,_cache: any) => {
  return (__props.thread.comments_count > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.thread.comments_count) + " ", 1),
            (__props.thread.comments_count === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Comment"))
              : _createCommentVNode("", true),
            (__props.thread.comments_count > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Comments"))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.thread.comments, (comment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: comment.id,
              class: "comments"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(CommentComponent, {
                  comment: comment,
                  onReplyShow: showReply
                }, null, 8, ["comment"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.replies, (reply) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: reply.id,
                  class: "comments__reply"
                }, [
                  _createVNode(CommentComponent, {
                    comment: reply,
                    onReplyShow: showReply
                  }, null, 8, ["comment"])
                ]))
              }), 128)),
              (isShowReply(comment))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(CommentReply, {
                      doc: __props.doc,
                      thread: __props.thread,
                      comment: comment,
                      onReplyPosted: hideReply
                    }, null, 8, ["doc", "thread", "comment"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})